// ────────────────────────────────────────────────────
// src/features/admin/components/ApplicationSettings.tsx
// ────────────────────────────────────────────────────
import React, { useState } from 'react';
import Tabs from '../../../../shared/components/ui/Tabs';
import CashFlowAdmin from '../../../services/cashRegister/components/CashFlowAdmin';   // ← NEW

type SubTab = 'Cash‑Flow';

export default function ApplicationSettings() {
  const subTabs: SubTab[] = ['Cash‑Flow'];
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('Cash‑Flow');

  return (
    <section className="bg-neutral-900 rounded-lg p-4 space-y-4">
      <Tabs
        tabs={subTabs}
        activeTab={activeSubTab}
        onTabChange={(t) => setActiveSubTab(t as SubTab)}
      />

      {/* ─── Cash‑Flow settings panel ─────────────────────────────── */}
      {activeSubTab === 'Cash‑Flow' && <CashFlowAdmin />}
    </section>
  );
}